import { render, staticRenderFns } from "./DetailsTasks.vue?vue&type=template&id=452e4f1c&scoped=true&"
import script from "./DetailsTasks.vue?vue&type=script&lang=js&"
export * from "./DetailsTasks.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTasks.vue?vue&type=style&index=0&id=452e4f1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e4f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VExpansionPanel,VExpansionPanelContent,VFlex,VIcon,VLayout,VList,VListTile,VListTileContent})
